import { render, staticRenderFns } from "./RemissionsTransferView.vue?vue&type=template&id=27d94655"
import script from "./RemissionsTransferView.vue?vue&type=script&lang=js"
export * from "./RemissionsTransferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports